module.exports = __webpack_public_path__ + "media/images/emblems/Graechen_Wappen-b978d69e2cf5015ab55f0e890fe706a6.png";